/*
 * @Author       : suzhen
 * @Email        : suzhen@dianzhong.com
 * @Date         : 2022-09-20 10:28:03
 * @LastEditors: suzhen suzhen@dianzhong.com
 * @LastEditTime: 2024-03-11 15:49:22
 * @Description  : 用户权限验证
 */
import router from './router/index.js'
import { getUserId } from '@/utils/cookie.js'
// const whiteList = ['/login','/agreement/yszc', '/agreement/yhxy', '/joinlogin', '/dowload'] // 白名单,不需要登录的路由

router.beforeEach((to, from, next) => {
	// 尝试获取cookie中的userId
	document.title = to.meta.title
	if (getUserId()) {
		// 有token缓存 用户已刷新
		if(to.path == '/login') {
			// 去首页
			router.replace({path: '/'})
		} else {
			next();
		}
	} else {
	// 	// 如果前往的路径是白名单内的,就可以直接前往
		if(to.meta.withoutLogin) next()
		else router.replace({path: '/login'})
	}
})

// router.afterEach((router)=>{
// 	// console.log('页面切换', router.meta.title)
// 	// afterLocationUrl()
// })

// window.addEventListener('click', (e)=>{
	// A.页面元素获得
	// let doms = document.querySelectorAll("*[data-dzname]")
	// for (let i = 0; i < doms.length; i++) {
	// 	const element = doms[i];
	// 	console.log(element.dataset, element.getBoundingClientRect())
		
	// }
	// console.log('点击了',e.target.dataset)
	// B.上报接口
	// fetch("/api/v1/Koc/user",
	// 	{
	// 		method: 'post',
	// 		headers: {
	// 			token: getUserId(),
	// 			Referer:'http://www.baidu.com/ditu',
	// 		},
	// 		body: JSON.stringify({name: 'dz'})
	// 	}
	//   ).then(res=>{
	// 	if(res.status == 200) {
	// 		return res.json()
	// 	} else res.json()
	//   }).then(res=>{
	// 	console.log('结果',res)
	// })

	

// })

// C.路径地址改变检测
// window.addEventListener('hashchange',(i)=>{
// 	console.log('hashchange',i)
// })

// window.addEventListener('popstate',(i)=>{
// 	console.log('popstate',i.state)
// })

// window.afterLocationUrl = function (){
// 	console.log('监听进入', location.href)
// }
